<h2 mat-dialog-title>{{ 'LOCATIONS.ARCHIVE_ALERT.ALERT_TITLE_ARCHIVE' | translate }}</h2>

<mat-dialog-content>
  <p [innerHTML]="'LOCATIONS.ARCHIVE_ALERT.ALERT_ARCHIVE' | translate"></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>
    <span class="button-name" fxHide.xs>{{ 'LOCATIONS.ARCHIVE_ALERT.CANCEL' | translate }} </span>
  </button>

  <button mat-button mat-dialog-close="true">
    <span class="button-name" fxHide.xs> {{ 'LOCATIONS.ARCHIVE_ALERT.ARCHIVE' | translate }} </span>
  </button>
</mat-dialog-actions>
